export enum Type {
  AJAX_POST_CREDIT_REPORT                   = 'AJAX_POST_CREDIT_REPORT',
  AJAX_POST_CREDIT_REPORT_FAIL              = 'AJAX_POST_CREDIT_REPORT_FAIL',
  AJAX_POST_CREDIT_REPORT_SUCCESS           = 'AJAX_POST_CREDIT_REPORT_SUCCESS',
  POLL_CREDIT_API                           = 'POLL_CREDIT_API',
}
